{
  const selectedTab = document.querySelector(".tab-is-selected"),
    isSelectedBtnBkgd = selectedTab
      ?.querySelector("button")
      ?.getAttribute("style");

  /**
   * @param {HTMLElement} slider
   * @param {number} idx
   */
  function setActiveSlide(slider, idx) {
    resetSlides(slider);
    const slide = slider.getElementsByClassName("slide")[idx],
      slideNav = slider.getElementsByClassName("slide-nav")[idx],
      slideNavButton = slideNav?.querySelector("button"),
      slideNavArrow = slideNav?.querySelector(".slide-nav-arrow");

    slide?.classList.remove("hidden");
    slideNav?.classList.add("tab-is-selected");
    slideNavArrow?.classList.remove("hidden");
    if (isSelectedBtnBkgd)
      slideNavButton?.setAttribute("style", isSelectedBtnBkgd);
  }

  function resetSlides(slider) {
    let slides = slider.getElementsByClassName("slide"),
      slidesNav = slider.getElementsByClassName("slide-nav");
    for (let x = 0; x < slides.length; x++) {
      slides[x]?.classList.add("hidden");
      slidesNav[x]?.classList.remove("tab-is-selected");
      slidesNav[x]?.querySelector(".slide-nav-arrow")?.classList.add("hidden");

      const slideNavButton = slidesNav[x]?.querySelector("button");

      slideNavButton?.removeAttribute("style");
    }
  }

  /**
   * @param {HTMLElement} slider
   * @param {number} idx
   */
  function slideClicked(slider, idx) {
    setActiveSlide(slider, idx);
  }

  const sliders = document.getElementsByClassName("slider");

  for (let x = 0; x < sliders.length; x++) {
    let slider = sliders[x];
    let slidesNav = slider.getElementsByClassName("slide-nav");
    for (let y = 0; y < slidesNav.length; y++) {
      slidesNav[y]?.addEventListener(
        "click",
        () => {
          slideClicked(slider, y);
        },
        false,
      );
    }

    setActiveSlide(slider, 0);
  }
}
